import React, { useState } from 'react';
import {
  PaymentElement,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';
import { Box, Typography } from '@mui/material';
import { Button, Space } from '@mantine/core';
import { primaryColor } from '../constants/theme';

const CheckoutForm: React.FC<{
  onPaymentProcessing?: (isProcessing: boolean) => void;
  reloadOnSuccess?: boolean;
}> = ({ onPaymentProcessing, reloadOnSuccess }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [message, setMessage] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    if (!stripe || !elements) {
      console.error('Stripe or elements not loaded');
      return;
    }

    setIsLoading(true);
    onPaymentProcessing?.(true);

    try {
      const result = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: window.location.href,
        },
      });

      if (result.error) {
        console.error('Payment failed:', result.error.message);
        setMessage(`Payment failed: ${result.error.message}`);
        onPaymentProcessing?.(false);
      } else if (reloadOnSuccess) {
        window.location.reload();
      }
    } catch (error) {
      console.error('Error confirming payment:', error);
      if (error instanceof Error) {
        setMessage(`Error confirming payment: ${error.message}`);
      } else {
        setMessage('An unknown error occurred');
      }
      onPaymentProcessing?.(false);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box>
      <form onSubmit={handleSubmit}>
        <PaymentElement />
        <Space h={10} />
        <Button
          type="submit"
          loading={isLoading}
          color={primaryColor}
          fullWidth
        >
          Submit
        </Button>
        <Space h={10} />
      </form>
      {message && (
        <Typography
          variant="body2"
          color={message.includes('succeeded') ? 'green' : 'red'}
          sx={{ mt: 2 }}
        >
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default CheckoutForm;
